module.exports = __webpack_public_path__ + "img/Menu.4bb20dec.svg";